import { UserLocation } from "custom-models";

import FlatResourceLine from "./FlatResourceLine";

type LocationLineProps = {
  patientLocation?: UserLocation;
  onEditLocation: Function;
};

const LocationLine = ({
  patientLocation,
  onEditLocation,
}: LocationLineProps) => {
  return (
    <FlatResourceLine resource={patientLocation} onEdit={onEditLocation}>
      <span>
        {patientLocation?.street}
        {patientLocation?.street2 && <>, {patientLocation?.street2}</>}
        <br />
        {patientLocation?.city}, {patientLocation?.state}{" "}
        {patientLocation?.zipcode}
        <br />
        Phone: {patientLocation?.phone1}
        <br />
        {patientLocation?.phone2 && (
          <>Additional Phone: {patientLocation?.phone2}</>
        )}
      </span>
    </FlatResourceLine>
  );
};

export default LocationLine;
